import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { colors, PageHeader } from 'z-react-components';
import styled from 'styled-components';
import { SwapPageStyles } from '../lib/SwapPage';

const PageHeaderContainer = styled.div`
    margin: 0 32px 24px 32px;
    border-bottom: 1px solid ${colors.grey300};

    @media (max-width: 767px) {
        margin: 0 24px 24px 24px;
    }
`;

const AppInfoContainer = styled.div`
    display: flex;
    padding: 0 32px 32px 32px;
    justify-content: space-between;

    @media (max-width: 767px) {
        padding: 0 24px 32px 24px;
    }

    @media (max-width: 1200px) {
        justify-content: flex-start;

        div:nth-child(2) {
            display: none;
        }
    }
`;

export const SubjectsInfoContainer = styled.div`
    background-color: ${colors.grey300};
    padding: 80px 32px 80px 32px;
    display: flex;

    @media (max-width: 767px) {
        padding: 80px 24px 80px 24px;
    }

    @media (max-width: 1200px) {
        flex-direction: column;
    }
`;

const SchoolTitle = styled.h4`
    font-weight: bold;
    margin-bottom: 32px;
`;

const Image = styled.img`
    width: 100%;
`;

export const MiddleSchoolContainer = styled.div`
    background-color: ${colors.white};
    display: flex;
    flex-direction: column;
    padding: 32px;
    width: calc(100% / 3);

    @media (max-width: 1200px) {
        width: 100%;
    }
    @media (min-width: 1600px) {
        width: 50%;
    }
`;

export const HighSchoolContainer = styled.div`
    background-color: ${colors.white};
    display: flex;
    flex-direction: column;
    padding: 32px;
    width: calc(100% / 3 * 2);
    margin-left: 32px;

    @media (max-width: 1200px) {
        width: 100%;
        margin-left: 0px;
        margin-top: 32px;
    }
    @media (min-width: 1600px) {
        width: 50%;
    }
`;
const MiddleSchoolContent = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    div:nth-child(2) {
        padding-left: 32px;
    }

    @media (max-width: 1599px) {
        flex-direction: column;
        justify-content: flex-start;

        & > div {
            width: 100%;
        }

        div:nth-child(2) {
            padding-left: 0px;
        }
    }
`;
const HighSchoolContent = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    div:nth-child(2) {
        padding-left: 32px;
    }

    @media (max-width: 1200px) {
        flex-direction: column;
        justify-content: flex-start;

        & > div {
            width: 100%;
        }

        div:nth-child(2) {
            padding-left: 0px;
        }
    }
`;

export default class Credits extends Component {
    static propTypes = {
        history: PropTypes.object
    };

    render() {
        const { history } = this.props;
        return (
            <div style={SwapPageStyles}>
                <PageHeaderContainer>
                    <PageHeader
                        actionBackButton={() => (document.referrer === '' ? history.push('/') : history.goBack())}
                        showBackButton={true}
                        title={'Credits'}
                    />
                </PageHeaderContainer>
                <AppInfoContainer>
                    <div>
                        <p>{'Coordinamento tecnico: Francesca Tiso, Andrea Malfer Poma, Davide Morri, Dario Robatto'}</p>
                        <p>{'Coordinamento redazionale: Francesca Tiso, Davide Morri, Dario Robatto'}</p>
                        <p>{'Progetto grafico e User experience: Pierleone Loreti, Beatrice Pedrini'}</p>
                        <p>
                            {'Sviluppo software:'}
                            <br />
                            {'Mondora.com, Milano'}
                            <br />
                            {'SPX Lab, Genova'}
                            <br />
                            {'Wondertech srl, Genova'}
                            <br />
                            {'duDAT srl, Bologna'}
                        </p>
                        <p>{'Digitalizzazione degli esercizi: Codemantra, Boston'}</p>
                        <p>{'Revisione degli esercizi: Edigeo s.r.l., Milano'}</p>
                    </div>
                    <div>
                        <Image src="./_assets/images/credits.svg" alt="Immagine credits" />
                    </div>
                </AppInfoContainer>
                <SubjectsInfoContainer>
                    <MiddleSchoolContainer>
                        <SchoolTitle>{'Scuola secondaria di primo grado'}</SchoolTitle>
                        <MiddleSchoolContent>
                            <div>
                                <p>{'Coordinamento redazionale arte e immagine: Valentina Marano, Anna Tonini'}</p>
                                <p>{'Creazione tassonomia arte e immagine: Rossana Delogu, Edigeo s.r.l., Milano'}</p>
                                <p>{'Taggatura esercizi arte e immagine: Edigeo s.r.l., Milano'}</p>
                                <p>{'Coordinamento redazionale geografia: Vittoria Balandi'}</p>
                                <p>{'Creazione tassonomia geografia: Arianna Volpini'}</p>
                                <p>{'Taggatura esercizi geografia: Michela Salvagno, Arianna Volpini'}</p>
                                <p>{'Coordinamento redazionale italiano: Andrea Zaninello'}</p>
                                <p>{'Creazione tassonomia italiano: Valeria di Marco'}</p>
                                <p>{'Taggatura esercizi italiano: Valeria di Marco'}</p>
                                <p>{'Coordinamento redazionale lingua inglese: Claudia Mazzocchi'}</p>
                                <p>{'Creazione tassonomia lingua inglese: Francesca Barbalace'}</p>
                                <p>{'Taggatura esercizi lingua inglese: Francesca Barbalace'}</p>
                                <p>{'Coordinamento redazionale lingua spagnola: Serena Matassoni'}</p>
                                <p>{'Creazione tassonomia lingua spagnola: Trinidad Fernández González, Edigeo s.r.l., Milano'}</p>
                                <p>{'Taggatura esercizi lingua spagnola: Edigeo s.r.l., Milano'}</p>
                            </div>
                            <div>
                                <p>{'Coordinamento redazionale matematica: Paola de Simone'}</p>
                                <p>{'Creazione tassonomia matematica: Mariangela Mazzanti'}</p>
                                <p>{'Taggatura esercizi matematica: Michele Santa Maria'}</p>
                                <p>{'Coordinamento redazionale scienze: Elena Baldi'}</p>
                                <p>{'Creazione tassonomia scienze: Elena Pallottini'}</p>
                                <p>{'Taggatura esercizi scienze: Elena Pallottini'}</p>
                                <p>{'Coordinamento redazionale storia: Laura Russo'}</p>
                                <p>{'Creazione tassonomia storia: Edigeo s.r.l., Milano'}</p>
                                <p>{'Taggatura esercizi storia: Edigeo s.r.l., Milano'}</p>
                                <p>{'Coordinamento redazionale tecnologia: Claudio Dutto, Matteo Fornesi'}</p>
                                <p>{'Creazione tassonomia tecnologia: Edigeo s.r.l., Milano'}</p>
                                <p>{'Taggatura esercizi tecnologia: Edigeo s.r.l., Milano'}</p>
                            </div>
                        </MiddleSchoolContent>
                    </MiddleSchoolContainer>
                    <HighSchoolContainer>
                        <SchoolTitle>{'Scuola secondaria di secondo grado'}</SchoolTitle>
                        <HighSchoolContent>
                            <div>
                                <p>{'Coordinamento redazionale biologia: Sara Urbani'}</p>
                                <p>{'Creazione tassonomia biologia: Anastasia Scotto'}</p>
                                <p>{'Taggatura esercizi biologia: Anastasia Scotto, Thomas Zanello'}</p>
                                <p>{'Coordinamento redazionale chimica: Matteo Fornesi, Martina Mugnai'}</p>
                                <p>{'Creazione tassonomia chimica: Giulia Pavarelli'}</p>
                                <p>{'Taggatura esercizi chimica: Lucio De Lorentiis, Giulia Pavarelli'}</p>
                                <p>{'Coordinamento redazionale diritto: Appears, Bologna'}</p>
                                <p>{'Creazione tassonomia diritto: Appears, Bologna'}</p>
                                <p>{'Taggatura esercizi diritto: Edigeo s.r.l., Milano'}</p>
                                <p>{'Coordinamento redazionale disegno tecnico: Matteo Fornesi'}</p>
                                <p>{'Creazione tassonomia disegno tecnico: Edigeo s.r.l., Milano'}</p>
                                <p>{'Taggatura esercizi disegno tecnico: Edigeo s.r.l., Milano'}</p>
                                <p>{'Coordinamento redazionale fisica: Serena Gradari'}</p>
                                <p>{'Creazione tassonomia fisica: Danilo Cinti'}</p>
                                <p>{'Taggatura esercizi fisica: Antonia Ricciardi'}</p>
                                <p>{'Coordinamento redazionale geografia: Vittoria Balandi'}</p>
                                <p>{'Creazione tassonomia geografia: Arianna Volpini, Edigeo s.r.l., Milano'}</p>
                                <p>{'Taggatura esercizi geografia: Edigeo s.r.l., Milano'}</p>
                                <p>{'Coordinamento redazionale greco: Giuliana Gambari'}</p>
                                <p>{'Creazione tassonomia greco: Edigeo s.r.l., Milano'}</p>
                                <p>{'Taggatura esercizi greco: Edigeo s.r.l., Milano'}</p>
                                <p>{'Coordinamento redazionale informatica: Matteo Fornesi'}</p>
                                <p>{'Creazione tassonomia informatica: Edigeo s.r.l., Milano'}</p>
                                <p>{'Taggatura esercizi informatica: Edigeo s.r.l., Milano'}</p>
                                <p>{'Coordinamento redazionale italiano: Andrea Zaninello'}</p>
                                <p>{'Creazione tassonomia italiano: Valeria di Marco, Andrea Zaninello'}</p>
                                <p>{'Taggatura esercizi italiano: Valeria di Marco'}</p>
                            </div>
                            <div>
                                <p>{"Coordinamento redazionale lingua francese: Chiara D'Oria"}</p>
                                <p>{'Creazione tassonomia lingua francese: Margot Legrand'}</p>
                                <p>{'Taggatura esercizi lingua francese: Edigeo s.r.l., Milano'}</p>
                                <p>{'Coordinamento redazionale lingua inglese: Isabella Araldi'}</p>
                                <p>{'Creazione tassonomia lingua inglese: Alessandra Liberati'}</p>
                                <p>{'Taggatura esercizi lingua inglese: Francesca Barbalace'}</p>
                                <p>{'Coordinamento redazionale lingua spagnola: Serena Matassoni'}</p>
                                <p>{'Creazione tassonomia lingua spagnola: Trinidad Fernández González'}</p>
                                <p>{'Taggatura esercizi lingua spagnola: Edigeo s.r.l., Milano'}</p>
                                <p>{'Coordinamento redazionale lingua tedesca: Claudia Mazzocchi'}</p>
                                <p>{'Creazione tassonomia lingua tedesca: Monica Gardenghi'}</p>
                                <p>{'Taggatura esercizi lingua tedesca: Edigeo s.r.l., Milano'}</p>
                                <p>{'Coordinamento redazionale matematica: Fabio Bettani, Elena Zaninoni'}</p>
                                <p>{'Creazione tassonomia matematica: Michele Santa Maria'}</p>
                                <p>{'Taggatura esercizi matematica: Michele Santa Maria'}</p>
                                <p>{'Coordinamento redazionale scienze della terra: Vittoria Balandi'}</p>
                                <p>{'Creazione tassonomia scienze della terra: Lucia Cantoni'}</p>
                                <p>{'Taggatura esercizi scienze della terra: Lucia Cantoni'}</p>
                                <p>{'Coordinamento redazionale scienza e cultura dell’alimentazione: Claudio Dutto, Eleonora Adorni'}</p>
                                <p>{'Creazione tassonomia scienza e cultura dell’alimentazione: Edigeo s.r.l., Milano'}</p>
                                <p>{'Taggatura esercizi scienza e cultura dell’alimentazione: Edigeo s.r.l., Milano'}</p>
                                <p>{'Coordinamento redazionale storia: Laura Russo'}</p>
                                <p>{'Creazione tassonomia storia: Edigeo s.r.l., Milano'}</p>
                                <p>{'Taggatura esercizi storia: Edigeo s.r.l., Milano'}</p>
                                <p>{"Coordinamento redazionale storia dell'arte: Gianluca Cané"}</p>
                                <p>{"Creazione tassonomia storia dell'arte: Rossana Delogu"}</p>
                                <p>{"Taggatura esercizi storia dell'arte: Edigeo s.r.l., Milano"}</p>
                                <p>{'Segreteria di redazione: Deborah Lorenzini'}</p>
                            </div>
                        </HighSchoolContent>
                    </HighSchoolContainer>
                </SubjectsInfoContainer>
            </div>
        );
    }
}
